import {
  getPartnerActivityPrice,
  getPartnerActivityDiscountedPrice,
  getPartnerActivityCurrency,
} from "./partnerActivityPricing";

const getPartnerActivityType = (duration, type = "plural") => {
  if (!duration) {
    return "";
  }
  if (duration.unit !== "days") {
    return type === "singular" ? "activity" : "activities";
  }

  if (duration.unit === "days" && duration.duration > 3) {
    return type === "singular" ? "tour" : "tours";
  }

  return type === "singular" ? "activity" : "activities";
};

export { getPartnerActivityType };

const providers = {
  gadventures(data) {
    const { departureInfo, returnInfo, canonicalCategory, duration, reviewCount, name, id } = data;
    const { booking, image } = data.links;

    return {
      name,
      price: getPartnerActivityDiscountedPrice(data) || getPartnerActivityPrice(data),
      currency: getPartnerActivityCurrency(data),
      link: booking,
      image: image && image.replace(/http:/, "https:"),
      category: canonicalCategory,
      type: getPartnerActivityType(duration, "singular"),
      duration: `${duration.duration} ${duration.unit}`,
      departs: departureInfo,
      arrives: returnInfo,
      reviews: reviewCount,
      id,
      poi: data,
    };
  },
  viator(data) {
    const { duration, canonicalCategory, name, reviewCount, id } = data;
    const { booking, image } = data.links;

    return {
      name,
      price: getPartnerActivityDiscountedPrice(data) || getPartnerActivityPrice(data),
      currency: getPartnerActivityCurrency(data),
      link: booking,
      image: image && image.replace(/http:/, "https:"),
      category: `${canonicalCategory}`,
      type: getPartnerActivityType(duration, "singular"),
      duration: `${duration.duration} ${duration.unit}`,
      departs: name,
      reviews: reviewCount,
      id,
      poi: data,
    };
  },
};

/**
 * Creates a unified inteface for displaying a tour or an activity
 * @param  {object} data A tour or activity object
 * @return {object} A unified tour or activity object
 */
export default function createPartnerActivity(data) {
  const providerFn = providers[data.provider];

  if (!providerFn) {
    return null;
  }

  return providers[data.provider](data);
}



// WEBPACK FOOTER //
// ./assets/pois/utils/createPartnerActivity.js